import styled from 'styled-components';

const StyledInputFooter = styled.footer`
  display: block;
  width: 100%;
  text-align: right;
  margin-top: 0.5rem;
`;

export default StyledInputFooter;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledInputFooter.js